import { useCallback, useMemo } from 'react';
import useUnitListByProject from '../../hooks/useUnitListByProject';
import { ModelUnit } from '../../models/modelUnitModel';
import { listToSelectOptionAdapter } from '../../adapters/listAdapter';
import Select from 'react-select';

interface Props {
  onModelUnitSelected: (modelUnit: ModelUnit) => void;
  projectId: string;
}

const ModelUnitListSelector = ({ onModelUnitSelected, projectId }: Props) => {
  const { error, isLoading, units } = useUnitListByProject({ projectId });

  const handleModelUnitChange = useCallback(
    (selectedOption: any) => {
      const modelUnit = selectedOption.value;
      const selectedUnit = units?.find((unit) => unit.unit_id === modelUnit);
      if (!selectedUnit) {
        console.error('Model unit not found');
        return;
      }
      onModelUnitSelected(selectedUnit);
    },
    [onModelUnitSelected, units],
  );

  const modelUnitOption = useMemo(() => {
    if (units) {
      const unitsAux = units.map((unit) => {
        return {
          id: unit.unit_id,
          name: `${unit.project_name} - ${unit.model_name} - [${unit.unit_name}]`,
        };
      });
      return listToSelectOptionAdapter(unitsAux, 'id', 'name', false);
    }
    return [];
  }, [units]);
  if (isLoading) {
    return <p>Loading model units...</p>;
  }

  if (error) {
    return <p>Error loading model units: {error}</p>;
  }
  return (
    <Select
      placeholder={'Selecciona la unidad'}
      options={modelUnitOption}
      onChange={handleModelUnitChange}
    />
  );
};

export default ModelUnitListSelector;
